import {PaneComponent, PaneComponentConfig} from "./pane_component";

export const SecondaryPaneComponentConfig = {
    baseHtmlClass: 'nav__pane--secondary',
    selector: '.nav__pane--secondary',

    scrollingBodySelector: '.nav__pane__body__content',
};

export class SecondaryPaneComponent extends PaneComponent {

    constructor(id_or_element, secondaryPane) {
        super(id_or_element, secondaryPane, PaneComponentConfig); // Note that we supply the PaneComponentConfig (not the SecondaryPaneComponentConfig)!
    }

    render() {
        this.conditionallySetHtmlClassState(!this.pane.readInternalStateValue('focused'), 'blurred');
        this.conditionallySetHtmlClassState(this.pane.readInternalStateValue('focused'), 'focused');

        this.conditionallySetHtmlClassState(this.pane.readInternalStateValue('active'), 'active');
        this.conditionallySetHtmlClassState(!this.pane.readInternalStateValue('active'), 'inactive');
    }

    getScrollingBodyElement() {
        return this.element.querySelector(SecondaryPaneComponentConfig.scrollingBodySelector);
    }

}